const methodsTypes = {
  'afterpay': 'waiting',
  'shoppay': 'waiting',
  'klarna': 'waiting',
}

window.addEventListener('DOMContentLoaded', () => {

  // Check if the methods are available and set the methodsTypes to null if not

  !!document.querySelector('klarna-placement') ? checkKlarna() : methodsTypes['klarna'] = null;
  !!document.querySelector('square-placement') ? checkAfterpay() : methodsTypes['afterpay'] = null;
  !!document.querySelector('shopify-payment-terms') ? checkShoppay() : methodsTypes['shoppay'] = null;
})

function checkKlarna() {

  let klarnaCounter = 0;
  const klarnaInterval = setInterval(() => {
    const klarnaPlacement  = document.querySelector('klarna-placement')

    if (!!klarnaPlacement?.shadowRoot?.querySelector('.badge-container')) {
      const klarnaBadge = klarnaPlacement.shadowRoot.querySelector('.badge-container svg');

      methodsTypes['klarna'] = klarnaBadge;

      clearInterval(klarnaInterval)
      setMethodsBadges(methodsTypes);
      setKlarnaPopup(klarnaPlacement);
    }
    else if ( klarnaCounter < 100) klarnaCounter += 1
    else {
      methodsTypes['klarna'] = null;
      setMethodsBadges(methodsTypes);
      clearInterval(klarnaInterval);
    }

  }, 100);
}

function checkAfterpay() {
  let afterpayCounter = 0;

  const afterpayInterval = setInterval(() => {

    const afterpayPlacement  = document.querySelector('square-placement')

    if (!!afterpayPlacement?.shadowRoot?.querySelector('.afterpay-logo')) {

      const afterpayBadge = afterpayPlacement.shadowRoot.querySelector('.afterpay-logo');
      const afterpayPopupLink = afterpayPlacement.shadowRoot.querySelector('.afterpay-link');

      afterpayBadge.closest('.afterpay-paragraph')?.prepend(afterpayBadge);
      methodsTypes['afterpay'] = afterpayBadge.querySelector('svg');

      clearInterval(afterpayInterval);
      setMethodsBadges(methodsTypes);

      let afterpayContentCaptured = false;
      afterpayPopupLink.addEventListener('click', (e) => {
        if (!afterpayContentCaptured) {
          afterpayContentCaptured = true;
          setAfterpayPopup(e);
        }
      });
      afterpayPopupLink.click();

      const afterpayStyles = document.createElement('style');
      afterpayStyles.textContent = `
        #logo-link {
          font-family: 'FS Industrie' !important;
        }

        .afterpay-paragraph {
          display: flex;
          gap: 6px;
        }
      `

      afterpayPlacement.shadowRoot.appendChild(afterpayStyles);

    }
    else if ( afterpayCounter < 100) afterpayCounter += 1
    else {
      methodsTypes['afterpay'] = null;
      setMethodsBadges(methodsTypes);
      clearInterval(afterpayInterval);
    }

  }, 100);
}

function checkShoppay() {
  let shoppayCounter = 0;

  const shoppayInterval = setInterval(() => {

    const shoppayPlacement  = document.querySelector('shopify-payment-terms')

    if (!!shoppayPlacement?.shadowRoot?.querySelector('#shopify-installments-content')) {

      const shoppayBadge = shoppayPlacement.shadowRoot.querySelector('#shopify-installments-content > div');
      document.querySelector('shopify-payment-terms').style.display = 'none'

      setTimeout(() => {

        shoppayBadge.parentElement.prepend(shoppayBadge);
        deleteNodeText(shoppayBadge.parentElement, ' with ');

  
      }, 100);

      methodsTypes['shoppay'] = shoppayBadge;

      clearInterval(shoppayInterval)
      setMethodsBadges(methodsTypes);
      setShoppayPopup();

      const shoppayStyles = document.createElement('style');
      shoppayStyles.textContent = `
        #shopify-installments-content {
          display: flex;
          gap: 6px;
          align-items: center;
        }

        #shopify-installments {
          font-family: 'FS Industrie' !important;
        }
      `

      shoppayPlacement.shadowRoot.appendChild(shoppayStyles);
    }
    else if ( shoppayCounter < 100) shoppayCounter += 1
    else {
      methodsTypes['shoppay'] = null;
      setMethodsBadges(methodsTypes);
      clearInterval(shoppayInterval);
    }

  }, 100);
}

function setMethodsBadges(methodsTypes) {

  const payLaterContainer = document.querySelector('.pay-later__container');
  payLaterContainer.classList.add('loading');

  // If the methods which are not klarna are still waiting, don't show the badges
  if (!!Object.keys(methodsTypes).find(method => method != 'klarna' && methodsTypes[method] === 'waiting')) return;

  const payLaterMethods = payLaterContainer?.querySelector('.pay-later__methods');
  const methodsAvailables = Object.keys(methodsTypes).filter(method => methodsTypes[method] !== null);

  payLaterMethods.innerHTML = ``;

  methodsAvailables.forEach((method,index) => {

    // If the method is waiting, create a loading element
    const clonedElement = methodsTypes[method] === 'waiting'
                          ? ( () => {
                            const div = document.createElement('div')
                            div.classList.add('pay-later__method--loading')
                            return div
                          })()
                          : methodsTypes[method].cloneNode(true);

    clonedElement.dataset.method = method;

    if (index == 0) {
      payLaterMethods.appendChild(clonedElement);
    } else {
      const separator = index == (methodsAvailables.length - 1) ? ' and' : ',';
      const span = document.createElement('span');
      span.textContent = separator;
      payLaterMethods.append(span, document.createTextNode(' '), clonedElement);
    }

  })

  const payLaterText = payLaterContainer?.querySelector('.pay-later__text');
  if (!!payLaterText) payLaterText.style.display = 'flex';

  payLaterContainer.classList.remove('loading');
}

function setKlarnaPopup(klarnaPlacement) {

  const clonedKlarnaInfo = klarnaPlacement.cloneNode(true);
  const customPopup = document.querySelector('.sp-popup__container');
  const customPopupInfo = customPopup.querySelector('.pay-later__popup-info');
  const customPopupTabs = customPopup.querySelector('.pay-later__popup-tabs');
  let klarnaInfo = document.createElement('div');
  let klarnaTab = document.createElement('span');

  klarnaInfo.classList.add('pay-later__popup-info--klarna', 'tab-container__js');
  klarnaInfo.dataset.name = 'klarna';
  klarnaInfo.appendChild(clonedKlarnaInfo);
  klarnaTab.textContent = 'Klarna';
  klarnaTab.classList.add('tab-heading__js');
  klarnaTab.style.order = '2';
  klarnaTab.dataset.name = 'klarna';

  customPopupInfo.appendChild(klarnaInfo);
  customPopupTabs.appendChild(klarnaTab);

}

function setShoppayPopup() {
  const shoppayPortalProvider = document.querySelector('[data-nametag="shop-portal-provider"]')
  const shoppayPopup  = shoppayPortalProvider?.shadowRoot?.querySelector('[data-testid="shopify-payment-terms-modal"]')

  if (!!shoppayPopup) {
    const clonedShoppayInfo = shoppayPopup.cloneNode(true);
    const customPopup = document.querySelector('.sp-popup__container');
    const customPopupInfo = customPopup.querySelector('.pay-later__popup-info');
    const customPopupTabs = customPopup.querySelector('.pay-later__popup-tabs');
    let shoppayInfo = document.createElement('div');
    let shopPayTab = document.createElement('span');

    shoppayInfo.classList.add('pay-later__popup-info--shoppay', 'tab-container__js');
    shoppayInfo.appendChild(clonedShoppayInfo);
    shoppayInfo.dataset.name = 'shoppay';
    shopPayTab.textContent = 'Shop Pay';
    shopPayTab.classList.add('tab-heading__js');
    shopPayTab.style.order = '1';
    shopPayTab.dataset.name = 'shoppay';

    customPopupInfo.appendChild(shoppayInfo);
    customPopupTabs.appendChild(shopPayTab);
  }
}

function setAfterpayPopup(e) {
  e.preventDefault();

  const afterPayModal = document.querySelector('afterpay-modal')
  let afterPayInfoCounter = 0;
  const afterPayInterval = setInterval(() => {

    const afterPayModalInfo = afterPayModal.shadowRoot.querySelector('.afterpay-modal-wrapper')

    if (!!afterPayModal?.shadowRoot?.querySelector('.afterpay-modal-wrapper')) {

      const clonedAfterPayInfo = afterPayModalInfo.cloneNode(true);
      const customPopup = document.querySelector('.sp-popup__container');
      const customPopupInfo = customPopup.querySelector('.pay-later__popup-info');
      const customPopupTabs = customPopup.querySelector('.pay-later__popup-tabs');

      let afterpayInfo = document.createElement('div');
      afterpayInfo.classList.add('pay-later__popup-info--afterpay', 'tab-container__js', 'tab-container__js--active');
      afterpayInfo.appendChild(clonedAfterPayInfo);
      afterpayInfo.dataset.name = 'afterpay';
      let afterPayTab = document.createElement('span');
      afterPayTab.textContent = 'Afterpay';
      afterPayTab.classList.add('tab-heading__js', 'tab-heading__js--active');
      afterPayTab.style.order = '0';
      afterPayTab.dataset.name = 'afterpay';

      customPopupInfo.appendChild(afterpayInfo);
      customPopupTabs.appendChild(afterPayTab);

      clearInterval(afterPayInterval);

      // Close the native Afterpay modal so it doesn't stay open when resizing to mobile
      closeAfterpayModal(afterPayModal);

    } else if (afterPayInfoCounter < 150) afterPayInfoCounter += 1
    else clearInterval(afterPayInterval)

  }, 100);
}

function closeAfterpayModal(afterPayModal) {
  if (!afterPayModal?.shadowRoot) return;
  const root = afterPayModal.shadowRoot;
  const closeButton =
    root.querySelector('[aria-label="Close"]') ||
    root.querySelector('[aria-label="close"]') ||
    root.querySelector('.afterpay-modal-close') ||
    root.querySelector('[data-close]') ||
    root.querySelector('button[class*="close"]');
  if (closeButton) {
    closeButton.click();
    return;
  }
  afterPayModal.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27, bubbles: true }));
}

function deleteNodeText(container, node) {

  // Traverse text nodes within the element
  const walker = document.createTreeWalker(
    container,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  while (walker.nextNode()) {
    const textNode = walker.currentNode;
    if (textNode.nodeValue.includes(node)) {
      textNode.nodeValue = textNode.nodeValue.replace(node, "");
    }
  }
}
